/**
 * Helpers for user PTO / time off.
 * Use when scheduling work or assigning gardeners to tasks.
 */

import { toLocalDateString } from './dateUtils';

export type TimeOffEntry = { start_date: string; end_date: string };

/**
 * Returns true if the given date falls within any of the user's time-off entries.
 * Uses local date (no UTC shift) so calendar cells match stored dates.
 */
export function isUserOnTimeOff(date: Date | string, timeOffEntries: TimeOffEntry[]): boolean {
	const d = typeof date === 'string' ? date : toLocalDateString(date);
	if (!Array.isArray(timeOffEntries) || timeOffEntries.length === 0) return false;
	return timeOffEntries.some(
		(entry) => entry.start_date <= d && d <= entry.end_date
	);
}
